var map = {
	"./ion-accordion_2.entry.js": [
		79,
		8592,
		79
	],
	"./ion-action-sheet.entry.js": [
		5593,
		8592,
		5593
	],
	"./ion-alert.entry.js": [
		3225,
		8592,
		3225
	],
	"./ion-app_8.entry.js": [
		4812,
		8592,
		4017
	],
	"./ion-avatar_3.entry.js": [
		6655,
		6655
	],
	"./ion-back-button.entry.js": [
		4856,
		8592,
		4856
	],
	"./ion-backdrop.entry.js": [
		3059,
		3059
	],
	"./ion-breadcrumb_2.entry.js": [
		8648,
		8592,
		8648
	],
	"./ion-button_2.entry.js": [
		8308,
		8308
	],
	"./ion-card_5.entry.js": [
		4690,
		4690
	],
	"./ion-checkbox.entry.js": [
		4090,
		4090
	],
	"./ion-chip.entry.js": [
		6214,
		6214
	],
	"./ion-col_3.entry.js": [
		9447,
		9447
	],
	"./ion-datetime-button.entry.js": [
		7950,
		9022,
		7950
	],
	"./ion-datetime_3.entry.js": [
		9689,
		9022,
		8592,
		9689
	],
	"./ion-fab_3.entry.js": [
		8840,
		8592,
		8840
	],
	"./ion-img.entry.js": [
		749,
		749
	],
	"./ion-infinite-scroll_2.entry.js": [
		9667,
		8592,
		9544
	],
	"./ion-input.entry.js": [
		3288,
		8592,
		3288
	],
	"./ion-item-option_3.entry.js": [
		5473,
		8592,
		6108
	],
	"./ion-item_8.entry.js": [
		3634,
		8592,
		3634
	],
	"./ion-loading.entry.js": [
		2855,
		2855
	],
	"./ion-menu_3.entry.js": [
		495,
		8592,
		495
	],
	"./ion-modal.entry.js": [
		8737,
		8592,
		8737
	],
	"./ion-nav_2.entry.js": [
		9632,
		8592,
		9632
	],
	"./ion-picker-column-internal.entry.js": [
		4446,
		8592,
		4446
	],
	"./ion-picker-internal.entry.js": [
		2275,
		2275
	],
	"./ion-popover.entry.js": [
		8050,
		8592,
		8050
	],
	"./ion-progress-bar.entry.js": [
		8994,
		8994
	],
	"./ion-radio_2.entry.js": [
		3592,
		3592
	],
	"./ion-range.entry.js": [
		5454,
		8592,
		5454
	],
	"./ion-refresher_2.entry.js": [
		290,
		8592,
		4210
	],
	"./ion-reorder_2.entry.js": [
		2666,
		8592,
		8718
	],
	"./ion-ripple-effect.entry.js": [
		4816,
		4816
	],
	"./ion-route_4.entry.js": [
		5534,
		5534
	],
	"./ion-searchbar.entry.js": [
		4902,
		8592,
		4902
	],
	"./ion-segment_2.entry.js": [
		1938,
		8592,
		1938
	],
	"./ion-select_3.entry.js": [
		8179,
		8179
	],
	"./ion-slide_2.entry.js": [
		668,
		668
	],
	"./ion-spinner.entry.js": [
		1624,
		8592,
		1624
	],
	"./ion-split-pane.entry.js": [
		9989,
		9989
	],
	"./ion-tab-bar_2.entry.js": [
		8902,
		8592,
		8902
	],
	"./ion-tab_2.entry.js": [
		199,
		8592,
		199
	],
	"./ion-text.entry.js": [
		8395,
		8395
	],
	"./ion-textarea.entry.js": [
		6357,
		6357
	],
	"./ion-toast.entry.js": [
		8268,
		8268
	],
	"./ion-toggle.entry.js": [
		5269,
		8592,
		5269
	],
	"./ion-virtual-scroll.entry.js": [
		2875,
		2875
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 863;
module.exports = webpackAsyncContext;